import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Component, createElement } from 'react';
import { ErrorBoundaryContext } from '../context/ErrorBoundaryContext';
import { captureError, hasArrayChanged } from '../utils';
const initialState = {
    didCatch: false,
    error: null,
    errorCount: 0,
};
export class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.resetErrorBoundary = this.resetErrorBoundary.bind(this);
        this.state = initialState;
    }
    static getDerivedStateFromError(error) {
        return {
            didCatch: true,
            error,
        };
    }
    resetErrorBoundary(...args) {
        var _a, _b;
        const { error, errorCount } = this.state;
        if (error !== null) {
            (_b = (_a = this.props).onReset) === null || _b === void 0 ? void 0 : _b.call(_a, {
                args,
                reason: "imperative-api",
            });
            this.setState(Object.assign(Object.assign({}, initialState), { errorCount }));
        }
    }
    componentDidCatch(error, info) {
        var _a, _b;
        this.setState((prevState) => ({
            errorCount: prevState.errorCount + 1,
        }));
        (_b = (_a = this.props).onError) === null || _b === void 0 ? void 0 : _b.call(_a, error, info);
        captureError(error, this.props.boundaryName, this.props.boundaryType, this.props.packageName, this.props.packageVersion, this.props.packageOwner, info);
    }
    componentDidUpdate(prevProps, prevState) {
        var _a, _b;
        const { didCatch } = this.state;
        const { resetKeys } = this.props;
        if (didCatch &&
            prevState.error !== null &&
            hasArrayChanged(prevProps.resetKeys, resetKeys)) {
            (_b = (_a = this.props).onReset) === null || _b === void 0 ? void 0 : _b.call(_a, {
                next: resetKeys,
                prev: prevProps.resetKeys,
                reason: "keys",
            });
            this.setState(initialState);
        }
    }
    componentDidMount() {
        if (this.props.errorOnMount) {
            this.setState({
                didCatch: true,
                error: this.props.errorOnMount,
                errorCount: this.state.errorCount + 1
            });
        }
    }
    render() {
        const { didCatch, error, errorCount } = this.state;
        const { children, fallbackComponent } = this.props;
        let elementToRender = children;
        if (didCatch) {
            if (fallbackComponent) {
                elementToRender = createElement(fallbackComponent, {
                    error,
                    resetErrorBoundary: this.resetErrorBoundary,
                    errorCount,
                });
            }
            else {
                elementToRender = createElement(() => _jsx(_Fragment, {}), {
                    error,
                    resetErrorBoundary: this.resetErrorBoundary,
                    errorCount,
                });
            }
        }
        return createElement(ErrorBoundaryContext.Provider, {
            value: {
                didCatch,
                error,
                resetErrorBoundary: this.resetErrorBoundary,
            }
        }, elementToRender);
    }
}
//# sourceMappingURL=ErrorBoundary.js.map